export const stringsKey = "TimeZoneSelection";
export const englishStrings = {
	timeZoneLabel: "Select Time Zone",
	timeZoneRequiredMessage: "The timezone field is required.",
};
